var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGatewayEuiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8109 8.86285H5.14746V1.35205C5.14746 0.963684 4.8327 0.648926 4.44434 0.648926C4.05597 0.648926 3.74121 0.963684 3.74121 1.35205V8.86285H3.18915C1.4306 8.86285 0 10.2935 0 12.0518V14.0013C0 15.2972 0.777283 16.4141 1.88965 16.9127V17.6479C1.88965 18.0363 2.20441 18.351 2.59277 18.351C2.98114 18.351 3.2959 18.0363 3.2959 17.6479V17.1905H20.7041V17.6479C20.7041 18.0363 21.0189 18.351 21.4072 18.351C21.7954 18.351 22.1104 18.0363 22.1104 17.6479V16.9127C23.2227 16.4141 24 15.2972 24 14.0013V12.0518C24 10.2935 22.5694 8.86285 20.8109 8.86285ZM20.4069 12.2411C20.4069 12.6295 20.0922 12.9443 19.7038 12.9443H18.3748C17.9866 12.9443 17.6717 12.6295 17.6717 12.2411C17.6717 11.853 17.9866 11.538 18.3748 11.538H19.7038C20.0922 11.538 20.4069 11.853 20.4069 12.2411Z",
    fill: "#00609B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayEuiIcon);
export default __webpack_public_path__ + "static/media/GatewayEuiIcon.7f440d1f733b670fe67780d227064ea4.svg";
export { ForwardRef as ReactComponent };